import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingContext, M_Table, NavigateContext } from 'src/M_Components'

export const MovementTypeEquipmentStatusList = ({ roles }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)

    const newRoute = (url, operation, label, row) => {
        if (operation === 'Edit' || operation === 'Copy') {
            if (row) {
                sessionStorage.setItem('editingMovementTypeEquipmentStatus', JSON.stringify(row))
                sessionStorage.setItem('operationType', operation)  
            } else {
                return
            }
        }
        if (operation === 'Create') ctx.setPassValues({ Operation: operation })
        ctx2.newTab(url, label)
    }

    return (
        <M_Table
            entityName={'MovementTypeEquipmentStatus'}
            api='secondary'
            showTitle={true}
            title={'Movement Types Equipment Status'} 
            roleName={'usersGroups'}
            rolePermissions={roles}
            replaceFunctions={new Map([
                ['Create', (row) => newRoute('containerControl/movTypeEqStatusCrud', 'Create', t('Add')+' '+t('Movement')+' '+t('Type')+' '+t('Equipment')+' '+t('Status'), row)],
                ['Edit', (row) => newRoute('containerControl/movTypeEqStatusCrud', 'Edit', t('Edit')+' '+t('Movement')+' '+t('Type')+' '+t('Equipment')+' '+t('Status'), row)],
                ['Copy', (row) => newRoute('containerControl/movTypeEqStatusCrud', 'Copy', t('Copy')+' '+t('Movement')+' '+t('Type')+' '+t('Equipment')+' '+t('Status'), row)]
            ])}
        />
    )
}